import { isServer } from '@helpers/env';

export function setSessionVariable(key: string, value: string) {
    if (isServer()) {
        return;
    }
    window.sessionStorage.setItem(key, value);
}

export function getSessionVariable(key: string) {
    if (isServer()) {
        return null;
    }
    return window.sessionStorage.getItem(key);
}

export function getSessionData<T>(key: string): T | null {
    const value = getSessionVariable(key);
    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value) as T;
    } catch {
        return null;
    }
}

export function removeSessionVariable(key: string) {
    if (isServer()) {
        return;
    }
    window.sessionStorage.removeItem(key);
}

export function setLocalVariable(key: string, value: string) {
    if (isServer()) {
        return;
    }
    window.localStorage.setItem(key, value);
}

export function getLocalVariable(key: string) {
    if (isServer()) {
        return null;
    }
    return JSON.parse(window.localStorage.getItem(key) ?? 'null');
}

export function getLocalDataIfNotExpired(key: string): string | null {
    if (isServer()) {
        return null;
    }
    const item = getLocalVariable(key);
    if (!item) {
        return null; // Item not found
    }

    if (item && typeof item === 'object' && Boolean(item.expiresTimestamp)) {
        const currentTime = Date.now();
        if (currentTime < item.expiresTimestamp) {
            return item;
        } else {
            // Item expired
            removeLocalVariable(key);
            return null;
        }
    } else {
        // No expiresTimestamp
        return item;
    }
}

export function removeLocalVariable(key: string) {
    window.localStorage.removeItem(key);
}
